<template>
  <div>
    <b-overlay :show="isLoadingData" rounded="sm">
      <b-row>
        <b-col cols="6" offset-md="3">
          <b-card header-tag="header">
            <template v-slot:header>
              <div class="float-left mt-3">
                <h6>Audit</h6>
              </div>
              <div class="mb-0 float-right">
                <b-button
                  class="mr-2"
                  variant="outline-warning"
                  size="sm"
                  @click="showAddCommentModal = !showAddCommentModal"
                >
                  <font-awesome-icon icon="comments" />
                </b-button>
                <b-dropdown
                  menu-class="menu-dropdown"
                  size="sm"
                  no-caret
                  class="m-2"
                  variant="outline-info"
                >
                  <template v-slot:button-content>
                    <font-awesome-icon icon="filter" />
                  </template>
                  <b-dropdown-form>
                    <b-form-checkbox
                      :disabled="showTpLogs == 0"
                      v-model="showUserComments"
                      value="1"
                      unchecked-value="0"
                      @input="getTpAuditTrails"
                    >Activity Changes</b-form-checkbox>
                    <b-form-checkbox
                      :disabled="showUserComments == 0"
                      v-model="showTpLogs"
                      value="1"
                      unchecked-value="0"
                      @input="getTpAuditTrails"
                    >Third Party Comments</b-form-checkbox>
                  </b-dropdown-form>
                </b-dropdown>
                <b-button
                  class="ml-2"
                  variant="outline-primary"
                  size="sm"
                  @click="printAuditTrail()"
                >
                  <font-awesome-icon icon="print" />
                </b-button>
              </div>
            </template>
            <b-card-body class="scrollFlow" style="height: 400px; overflow: hidden auto;">
              <ul class="timeline">
                <li v-for="(data,index) in auditTrailsData" :key="index">
                  <p class="text-muted">{{ data.inserted_date }}</p>
                  <p v-html="sanitizeHtml(data.title)"></p>
                  <div v-if="data.reason != undefined && data.reason">
                    <br />
                    <p class="text-muted" v-html="sanitizeHtml(data.reason)"></p>
                  </div>
                </li>
              </ul>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>

    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Add Comment"
      v-model="showAddCommentModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-form-group>
            <b-form-textarea
              id="textarea"
              v-model="$v.form.commentInput.$model"
              :state="$v.form.commentInput.$dirty ? !$v.form.commentInput.$error : null"
              placeholder="Enter Comment..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Audit Comment adding......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Audit Comment has been added successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" variant="outline-danger" @click="resetModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation()"
        >Add</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import config from "../../../configs/config";
export default {
  name: "AuditTrailTabComponent",
  mixins: [validationMixin],
  data() {
    return {
      showUserComments: "1",
      showTpLogs: "1",
      isLoadingData: false,
      auditTrailsData: [],
      form: {
        commentInput: null
      },
      showAddCommentModal: false,
      submiting: false,
      responseSuccess: false
    };
  },
  validations: {
    form: {
      commentInput: { required }
    }
  },
  mounted() {
    this.getTpAuditTrails();
  },
  methods: {
    sanitizeHtml,
    async getTpAuditTrails() {
      this.auditTrailsData = [];
      let formData = {
        showUserComments: this.showUserComments,
        showTpLogs: this.showTpLogs,
        thirdPartyId: this.$route.params.thirdPartyId,
        companyId: this.$route.params.companyId
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingData = true;
        let result = await HTTP("post", "thirdparty/audittrails", formData, {
          Authorization: token
        });
        if (result && result.data.status == 1 && result.status == 200) {
          this.auditTrailsData = result.data.response;
          this.isLoadingData = false;
          this.$store.state.auditTrailTabLazyLoad = false;
        } else {
          this.auditTrailsData = [];
          this.isLoadingData = false;
          this.$store.state.auditTrailTabLazyLoad = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.addTpAuditTrailComment().then(this.getTpAuditTrails);
      }
    },
    async addTpAuditTrailComment() {
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId,
        companyId: this.$route.params.companyId,
        comment: this.form.commentInput,
        memberId: localStorage.getItem("userId")
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoadingData = true;
        await HTTP("post", "thirdparty/add/audittrailcomment", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoadingData = false;
        this.responseSuccess = true;
      } catch (err) {
        return [err];
        // // console.log("------------erroror", err);
      }
    },
    resetModal() {
      this.form.commentInput = null;
      this.submiting = false;
      this.isLoadingData = false;
      this.responseSuccess = false;
      this.showAddCommentModal = false;
      this.$v.form.$reset();
    },
    printAuditTrail() {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/audit_trail_get.php?vid=" + this.$route.params.thirdPartyId + "&filter_1=" + this.showUserComments + "&filter_2=" + this.showTpLogs;
      window.open(urlAddress);
    }
  }
};
</script>
<style>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
.menu-dropdown {
  min-width: 15rem;
}
</style>